import { FAILED, LOADING, SUCCESS } from './constants';
import { productStock } from '../../utils/api';
import { initialDataStock } from './reducer';

export const fetchStock = (params = {}) => {
  return async (dispatch) => {
    const key = 'Stock';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await productStock(params);
      const summary = { ...initialDataStock };
      data.forEach((stock) => {
        summary[stock.category.toLowerCase()] = stock;
      });
      dispatch(successAction(summary, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key) {
  return { type: SUCCESS, data, key };
}
